module.exports = __webpack_public_path__ + "img/origin.69d051f4.png";